import Badge from "theme/components/badges/Badge";
import styled from "theme/libs/styled";

const YellowBadge = styled(Badge)`
    background-color: ${({ theme }) => `${theme.colors.yellow_400}`};
    color: ${({ theme }) => `${theme.colors.black}`};
`;

export default YellowBadge;
